import express, { Router } from 'express';
import multer from 'multer';
import * as webhookController from '@/modules/webhook/webhook.controller';

const router: Router = express.Router();
const upload = multer();



router
  .route('/:companyId/:captureLeadId')
  .post(upload.none(), webhookController.createLeadByWebhook);

router
  .route('/:companyId/:captureLeadId/:platform')
  .post(upload.none(), webhookController.createLeadByWebhook);


export default router;
